/**
 * Сервисы, где читатель из России может заплатить картой «Мир». Проверено на их страницах
 * 29.09.2026: KiwiTaxi («VISA и MasterCard и МИР»), Tripster («картой российского банка можно
 * оплатить любую экскурсию»), Trip.com (только в рублях на ru.trip.com — валюту ставит
 * withReaderCurrency в /api/r). Localrent — по обзорам и по клиентам из России в кабинете.
 * Cherehapa — рублёвый агрегатор российских страховщиков (наша прямая программа, partnerId 13000);
 * «Мир» — по коду формы оплаты. EKTA «Мир» не принимает (INSURANCE_FLIGHTS_TOPICS_2026-09-29 §2).
 *
 * На RU-страницах их ставим первыми: 81% поисковых кликов сайта — русскоязычные, 30% из них
 * читают из России и Беларуси, а 70% RU-кликов уходило в сервисы, где карта РФ не проходит
 * (docs/audits/AFFILIATE_NETWORKS_2026-09-29.md §5–6). EN-страниц порядок не касается.
 */
const MIR_PROVIDER_CODES = new Set(['localrent', 'kiwitaxi', 'tripster', 'trip', 'cherehapa']);

// Только для русскоязычного читателя: сайт и оплата на русском и в рублях. На EN-странице такой
// провайдер — тупик (Cherehapa стояла на EN-лендингах страховки, разведка 29.09.2026).
// Поле `languages` провайдера для этого не годится: оно про языки его сайта, а не про аудиторию
// (у Viator там нет ru, хотя на RU-страницах он нужен).
const RU_ONLY_CODES = new Set(['cherehapa']);

// Зеркально: не для русскоязычного читателя. EKTA не принимает «Мир», а её сайт не открывается
// из России — решение владельца 01.10.2026 убрать её со всех RU-страниц (страхование — Cherehapa).
const NOT_RU_CODES = new Set(['ekta']);

/** Можно ли показывать провайдера читателю этого языка. */
export function isProviderForReader(code, language) {
    if (language === 'ru') return !NOT_RU_CODES.has(code);
    return !RU_ONLY_CODES.has(code);
}

export function mirFirst(providers, language) {
    if (language !== 'ru' || !Array.isArray(providers)) return providers;
    const rank = (provider) => (MIR_PROVIDER_CODES.has(provider?.code) ? 0 : 1);
    return [...providers].sort((a, b) => rank(a) - rank(b));
}

export function forReaderLanguage(providers, language) {
    if (!Array.isArray(providers)) return providers;
    const allowed = providers.filter((provider) => isProviderForReader(provider?.code, language));
    return language === 'ru' ? mirFirst(allowed, language) : allowed;
}
